import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import OverlineChip from './OverlineChip'

interface SectionIntroProps {
  overline?: string
  heading: string
  body?: string
  align?: 'left' | 'center'
}

export default function SectionIntro({ overline, heading, body, align = 'left' }: SectionIntroProps) {
  return (
    <Box sx={{ textAlign: align, mb: 5 }}>
      {overline && <OverlineChip label={overline} />}
      <Typography variant="h3" sx={{ mb: 2, fontSize: { xs: '1.6rem', md: '2rem' } }}>
        {heading}
      </Typography>
      {align === 'left' && (
        <Divider
          sx={{
            width: 56,
            borderWidth: 3,
            borderColor: 'secondary.main',
            mb: body ? 2.5 : 0,
          }}
        />
      )}
      {body && (
        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            maxWidth: align === 'center' ? 640 : '100%',
            mx: align === 'center' ? 'auto' : 0,
          }}
        >
          {body}
        </Typography>
      )}
    </Box>
  )
}
